import { useEffect, useState } from "react";
import { useParams, useSearchParams } from "react-router-dom";
import api, { formatErr } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { MailX, CheckCircle2 } from "lucide-react";

export default function UnsubscribePage() {
  const { customerId } = useParams();
  const [params] = useSearchParams();
  const [info, setInfo] = useState(null);
  const [done, setDone] = useState(false);
  const [error, setError] = useState("");

  useEffect(() => {
    api.get(`/public/unsubscribe-info/${customerId}`)
      .then((r) => { setInfo(r.data); if (r.data.unsubscribed) setDone(true); })
      .catch((e) => setError(formatErr(e)));
  }, [customerId]);

  const unsubscribe = async () => {
    try {
      await api.post("/public/unsubscribe", { customer_id: customerId, campaign_id: params.get("c") || null });
      setDone(true);
    } catch (e) {
      setError(formatErr(e));
    }
  };

  return (
    <div className="min-h-screen bg-[#0B0F17] flex items-center justify-center p-4">
      <div className="w-full max-w-md bg-[#111827] border border-slate-800 rounded-xl p-8 text-center fade-up">
        {done ? (
          <>
            <CheckCircle2 size={44} className="mx-auto text-emerald-400 mb-4" />
            <h1 className="font-heading text-xl font-bold text-slate-50 mb-2">You're unsubscribed</h1>
            <p data-testid="unsubscribe-done-message" className="text-sm text-slate-400">You will no longer receive marketing emails at {info?.email || "this address"}.</p>
          </>
        ) : error ? (
          <p className="text-sm text-rose-400">{error}</p>
        ) : (
          <>
            <MailX size={44} className="mx-auto text-slate-400 mb-4" />
            <h1 className="font-heading text-xl font-bold text-slate-50 mb-2">Unsubscribe from emails</h1>
            <p className="text-sm text-slate-400 mb-6">Stop receiving marketing emails at {info?.email || "…"}?</p>
            <Button data-testid="unsubscribe-confirm-button" onClick={unsubscribe} className="bg-rose-500 hover:bg-rose-600 text-white">
              Unsubscribe me
            </Button>
          </>
        )}
      </div>
    </div>
  );
}
